import React from "react";
import Layout from "../components/TheLayout";

import { Icon, Row, Col } from "antd";
import map from "../img/FCUB_map.jpg";
const ContactPage = () => {
  return (
    <Layout>
      <Row>
        <Col span={24}>
          <div className="contact-hero" />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <div
            style={{
              maxWidth: "65%",
              margin: "20px auto",
              textAlign: "center",
              color: "#474487"
            }}
          >
            <h1>Contact us</h1>
            <p>
              <Icon type="mail" style={{ marginRight: "5px" }} />
              orgchembiocat AT gmail &bull; com
            </p>

            <p>
              <Icon type="bank" style={{ marginRight: "5px" }} />
              University of Belgrade – Faculty of Chemistry
              <br />
              Studentski trg 12-16, 11000 Belgrade, Serbia
            </p>
            <img
              src={map}
              alt="Image of the Faculty of Chemistry map"
              style={{ maxHeight: "450px", maxWidth: "100%" }}
            />
          </div>
        </Col>
      </Row>
    </Layout>
  );
};

export default ContactPage;
